import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="24" height="24" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M8 11l4-4-4-4M12 7H1" className={styles["accent"] || "accent"} stroke="#81B5A1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M16 13V1" stroke="#F7F7F7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>);